<template>
  <div id="tree-sidebar" :class="{ open }">
    <div class="backdrop"></div>
    <div class="bar">
      <div class="title">
        <div>
          <div class="occupation">
            {{nodeRef.cargo}}
          </div>
          <div class="area">
            {{nodeRef.area}}
          </div>
        </div>
        <div class="arrow" @click="open = false;">
          <img :src="ThinArrow" alt="fechar">
        </div>
      </div>
      <div class="content" v-html="nodeRef.description.replace(/\r?\n/gi, '<br />')" />
    </div>
  </div>
</template>

<script>
  import EventSystem from '../utils/EventSystem';
  import ThinArrow from 'Assets/images/thin-arrow.svg';

  export default {
    props: {
    },
    data() {
      return {
        ThinArrow,
        open: false,
        nodeRef: { cargo: '', area: '', description: '' },
      };
    },
    created() {
      EventSystem.$on('tree-view-sidebar-open', node => {
        this.open = true;
        this.nodeRef = node;
      });

      EventSystem.$on('keypress-esc', () => {
        this.open = false;
      });
    },
    computed: {
    },
    methods: {
    },
  };

</script>



// WEBPACK FOOTER //
// assets/js/source/vue-ui/tree-sidebar.vue